export const CHARITABLE_ORGANIZATION_TYPES = {
  '501c3': '501(c)(3) - Public Charity',
  '501c4': '501(c)(4) - Social Welfare Organization',
  '501c6': '501(c)(6) - Business League',
  '501c7': '501(c)(7) - Social Club',
  '501c8': '501(c)(8) - Fraternal Organization',
  '501c19': '501(c)(19) - Veterans Organization',
  '501c25': '501(c)(25) - Title Holding Corporation',
  'Other': 'Other'
} as const;

export const CHARITABLE_ORGANIZATION_JURISDICTIONS = {
  'US': 'United States',
  'CA': 'Canada',
  'UK': 'United Kingdom',
  'AU': 'Australia',
  'Other': 'Other'
} as const;
